import {
  GET_SPECIAL_INFO_REQUEST,
  GET_APP_DETAILS,
  GET_SPECIALLIST_TAGS,
  GET_SPECIALLIST_LIST,
  GET_SPECIALLIST_BY_SOURCE,
  RESET_RESET_SPRCIAL_INFO,
  SET_SPECIAL_ZAN,
  GET_SPECIAL_LIST_LOADING,
} from '../constants/special';

export const getSpecialInfo = param => ({
  type: GET_SPECIAL_INFO_REQUEST,
  ...param,
});

export const getAppDetails = param => ({
  type: GET_APP_DETAILS,
  ...param,
});

export const getSpecialListTags = param => ({
  type: GET_SPECIALLIST_TAGS,
  payload: param,
});

export const getSpecialListList = param => ({
  type: GET_SPECIALLIST_LIST,
  payload: param,
});

export const getSpecialListBySource = param => ({
  type: GET_SPECIALLIST_BY_SOURCE,
  payload: param,
});

export const resetSpecialInfo = param => ({
  type: RESET_RESET_SPRCIAL_INFO,
  payload: param,
});

export const setSpecialZan = param => ({
  type: SET_SPECIAL_ZAN,
  payload: param,
});

export const getSpecialLoading = param => ({
  type: GET_SPECIAL_LIST_LOADING,
  payload: param,
});
